<template lang="pug">
  #modelMap.comAll(v-dragDiv,v-show="!actionData.isMini")
    .title.moveDragDiv
      span {{actionData.cnName}}
      i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
      i.el-icon-close(title='关闭' @click='closeAdd')
    .nav
      el-image(:src="showImg ? imgShow : imgHide" title="图状列表" class="showImg" @click="showImg = !showImg")
      el-input(placeholder='请输入图纸名称',size="mini",suffix-icon='el-icon-search' v-model='mapName')
    .list
      template(v-if="showImg")
        .dwgInfo(v-for='(ele,index) in mapList' :key='index' @click="openmodelDwg(ele)")
          template(v-if="mlibEnabled")
            el-image(:src='ele.downloadUrl' alt='图纸缩略图')
            p(:title='ele.drawName') {{ele.drawName}}
          template(v-else)
            el-image(:src='ele.imgurl' alt='图纸缩略图')
            p(:title='decodeURIComponent(ele.picName)') {{decodeURIComponent(ele.picName)}}
      template(v-else)
        el-tree.dwgTree(:data="mapTreeData" default-expand-all v-slot="{ node, data }")
          template(v-if="!data.modelId")
            .nodeItem
              span {{ data.nodeName }}
          template(v-else)
            .nodeItem(@click="openmodelDwg(data)")
              el-image(:src="dwgIcon", fit="contain", class="dwgIcon")
              span {{ data.nodeName }}
  </template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import mongeService from "@/CommonDP/mongeView/service/monge-service";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data () {
    return {
      showImg: true,
      imgHide: require("@/CommonDP/assets/workProjectBoard/imgHide.png"), // 图状隐藏
      imgShow: require("@/CommonDP/assets/workProjectBoard/imgShow.png"), // 图状展示
      dwgIcon: require("@/CommonDP/assets/projectMg/dwg.svg"), // tree图标
      mapName: '',
      groupPics: []
    };
  },
  computed: {
    mlibEnabled() {
      return mongeApp.mlibEnabled;
    },
    modelInfoData() {
      return JSON.parse(mongeApp.model.fileInfo);
    },
    allFileList() {
      return mongeApp.model.allFileList;
    },
    modelReady() {
      return mongeApp.model.modelReady;
    },
    mapList() {
      if (this.mlibEnabled) {
        return this.groupPics.filter(e => e.drawName?.includes(this.mapName));
      } else {
        return this.groupPics.filter(e => decodeURIComponent(e.picName)?.includes(this.mapName));
      }
    },
    // 树型结构数据
    mapTreeData() {
      const list = this.mapList || [];
      return this.arrayToTree(list);
    }
  },
  watch: {
    modelReady(val) {
      if (val) this.loadMapList();
    }
  },
  mounted () {
    if (this.modelReady) this.loadMapList();
  },
  methods: {
    // 数组转树型结构
    arrayToTree(list) {
      if (!list.length) return [];
      let treeData = [];
      if (this.modelInfoData?.fileObj) { // 多文件
        treeData = this.modelInfoData.fileObj.map(file => {
          const { folderID, folderName } = file;
          return { fileId: folderID, fileName: folderName };
        });
      } else if (this.modelInfoData?.fileId) { // 单文件
        const { fileId, fileName } = this.modelInfoData;
        const item = { fileId, fileName };
        treeData.push(item);
      }
      treeData = treeData.map(file => {
        const { fileId, fileName } = file;
        const node = { nodeName: fileName };
        if (this.mlibEnabled) {
          const children = list.filter(element => element.fileId === fileId);
          node.children = children.map(draw => {
            return { ...draw, nodeName: draw.drawName };
          });
          node.children = this.handleChildren(node.children);
        } else {
          const children = list.filter(element => element.fileId === fileId);
          node.children = children.map(pic => {
            return { ...pic, nodeName: pic.picName };
          });
          node.children = this.handleChildren(node.children);
        }
        return node;
      });
      return treeData;
    },
    // 处理子级（按图纸名称分级）
    handleChildren(children) {
      const nodeNames = children.map(({ nodeName }) => {
        if (!nodeName.includes("-")) return "";
        const name = nodeName.substring(0, nodeName.indexOf("-"));
        return name;
      });
      const names = [...new Set(nodeNames)];
      let newChildren = names.map(name => {
        return { nodeName: name, children: [] };
      });
      newChildren.forEach(item => {
        const list = children.filter(ele => ele.nodeName?.includes(item.nodeName));
        item.children = [...list];
      });
      const otherList = children.filter(ele => {
        const exist = names.some(name => ele.nodeName?.includes(name));
        return !exist;
      });
      newChildren = [...newChildren, ...otherList];
      return newChildren;
    },
    async loadMapList() {
      this.groupPics = [];
      if (this.mlibEnabled) {
        const models = await mongeApiMlib.getModels();
        let modelAttrList = [];
        models.forEach(element => {
          const bimexDetailList = element.url?.bimexDetailList;
          const array = bimexDetailList.map(i => {
            return { ...i, modelId: element.id };
          });
          modelAttrList = [...modelAttrList, ...array];
        });
        this.groupPics = modelAttrList.filter(ele => ele.label === "2D-IMG");
      } else {
        if (this.modelInfoData.fileObj) { // 多文件
          this.multiMaps();
        } else if (this.modelInfoData.fileId) { // 单文件
          this.singleMap();
        }
      }
    },
    async multiMaps() {
      for (const iterator of this.modelInfoData.fileObj) {
        await this.getDwgList(iterator.folderID, iterator.rvtVersion);
      }
    },
    singleMap() {
      const fileId = this.modelInfoData.fileId;
      const rvtVersion = this.modelInfoData.rvtVersion || "";
      this.getDwgList(fileId, rvtVersion);
    },
    async getDwgList(fileId, rvtVersion) {
      const { data } = await mongeService.queryDwgList(fileId, rvtVersion);
      const list = mongeApiMlib.assembleMapUrl(data, fileId, rvtVersion);
      this.groupPics = [...this.groupPics, ...list];
    },
    async openmodelDwg(data) {
      mongeMutations.setHasDwg(true);
      await this.$nextTick();
      if (this.mlibEnabled) {
        const { drawName, modelId } = data;
        mongeMutations.setModelPageFileName(decodeURIComponent(drawName));
        const url = this.allFileList.filter(item => item.drawName === drawName && item.label === "2D");
        const bimexDetailList = [];
        url.forEach(e => {
          if (!e.drawName) return;
          const bimexItemFile = {
            originFileName: e.lightFileName,
            url: e.downloadUrl,
            fileId: e.fileId
          };
          bimexDetailList.push(bimexItemFile);
        });
        const spaceWithDetailItems = {
          bimexId: drawName,
          bimexName: drawName,
          convertFilePathId: drawName,
          bimexDetailList
        };
        const params = { url: spaceWithDetailItems, id: 'dwgbox', longforLoading: false, modelId };
        await mongeApiMlib.load2D(params);
      } else {
        const { picsurl, picName, modelFileId, rvtVersion } = data;
        mongeMutations.setModelPageFileName(decodeURIComponent(picName));
        await this.$nextTick();
        const params = {
          url: picsurl,
          id: 'dwgbox',
          longforLoading: false,
          modelFileId,
          rvtVersion
        };
        await mongeApiMlib.load2D(params);
      }
    },
    miniCom() {
      this.$emit("closeCom", 'modelMap', true);
    },
    closeAdd() {
      this.$emit("closeCom", 'modelMap', false);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
#modelMap{
  position: fixed;
  top: 65px;
  left: 151px;
  width: 300px;
  height: calc(100% - 190px);
  max-height: 770px;
  .nav{
    height: 42px;
    padding: 7px 12px;
    display: flex;
    align-items: center;
    .showImg{
      flex-shrink: 0;
      width: 13px;
      height: 13px;
      margin-right: 12px;
      cursor: pointer;
    }
  }
  .list{
    width: 100%;
    height: calc(100% - 82px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    padding: 0 18px;
    .dwgInfo {
      width: 100%;
      height: 200px;
      border-bottom: 1px solid #b9bdc4;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 0 5px 0;
      .el-image {
        width: 90%;
        height: 127px;
      }
      p {
        width: 100%;
        text-align: center;
        font-size: 14px;
        line-height: 30px;
        color: #2c3e50;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.dwgTree{
  width: 100%;
  .nodeItem{
    display: flex;
    align-items: center;
    .dwgIcon{
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      margin-right: 12px;
    }
    span{
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
